export default function initSolarCarousel() {
    // ==========================================================
    // SOLAR CAROUSEL
    // ==========================================================

    const solarCarousels = document.querySelectorAll("[data-solar-carousel]");

    solarCarousels.forEach((carousel) => {
        const cards = Array.from(carousel.querySelectorAll("[data-solar-card]"));

        const prevButton = carousel.querySelector(".solar-carousel__arrow--prev");

        const nextButton = carousel.querySelector(".solar-carousel__arrow--next");

        if (!cards.length) {
            return;
        }

        // Deuxième carte active par défaut
        let activeIndex = cards.length > 1 ? 1 : 0;

        const renderCarousel = () => {
            const total = cards.length;

            const prevIndex = (activeIndex - 1 + total) % total;

            const nextIndex = (activeIndex + 1) % total;

            cards.forEach((card, index) => {
                card.classList.remove("is-active", "is-prev", "is-next", "is-hidden");

                if (index === activeIndex) {
                    card.classList.add("is-active");

                    return;
                }

                if (index === prevIndex) {
                    card.classList.add("is-prev");

                    return;
                }

                if (index === nextIndex) {
                    card.classList.add("is-next");

                    return;
                }

                card.classList.add("is-hidden");
            });
        };

        // PREVIOUS

        if (prevButton) {
            prevButton.addEventListener("click", () => {
                activeIndex = (activeIndex - 1 + cards.length) % cards.length;

                renderCarousel();
            });
        }

        // NEXT

        if (nextButton) {
            nextButton.addEventListener("click", () => {
                activeIndex = (activeIndex + 1) % cards.length;

                renderCarousel();
            });
        }

        // INITIAL STATE

        renderCarousel();
    });
}